import React from 'react'
import Form from 'react-bootstrap/Form';
const Reusablehop_category_brand_main = (icon,color) => {
  return (
    <>
    <li>
        <div className='hop_category_brand_form'>
            <Form>
                <Form.Check
                    inline
                    type="checkbox"
                    id="inline-checkbox-1"
                />
            </Form>
        </div>
        <div className='hop_category_brand_icon'>
            <i  class={icon} style={{color: '#FFAE00'}} ></i>
            <i class="fa-solid fa-star"  style={{color}} ></i>
            <i class="fa-solid fa-star" style={{color: '#FFAE00'}} ></i>
            <i class="fa-solid fa-star" style={{color: '#FFAE00'}} ></i>
            <i class="fa-solid fa-star" style={{color: '#FFAE00'}} ></i>
            <i class="fa-solid fa-star"  style={{color: '#E1E1E1' }}></i>
           
        </div>
    </li>
    </>
  )
}

export default Reusablehop_category_brand_main